<template>
  <div class="page-container pt-3 pb-4 haskamos-page">
    <div class="title d-flex justify-content-between align-items-center mb-2">
      <h3>{{ $t("heading") }}</h3>
    </div>
    <carousel
      v-if="approbations"
      :loop="true"
      :autoplay="true"
      :scrollPerPage="false"
      :perPage="1"
      :paginationEnabled="false"
    >
      <slide
        v-for="approbation in approbations"
        :key="approbation.id"
        class="text-center mt-4 mb-5"
        v-if="approbation.banner_file"
      >
        <b-img :src="approbation.banner.url" fluid class="w-100" />
      </slide>
    </carousel>
    <ul class="row list-unstyled align-items-stretch">
      <li
        class="col-12 col-md-6 col-lg-4 mt-4 mb-2 mb-lg-4 p-3 p-lg-4"
        v-for="(approbation, index) in approbations"
        :key="approbation.id"
      >
        <div class="card shadow-sm h-100">
          <b-img
            :src="approbation.preview.url"
            fluid
            class="card-img-top"
            @click="openGallery(index)"
          />
          <div class="card-body" @click="openGallery(index)">
            <h5 class="card-title">{{ approbation.name }}</h5>
            <p class="card-text">{{ approbation.preview_text }}</p>
          </div>
          <div class="card-footer p-0">
            <a
              :href="approbation.pdf.url"
              target="_blank"
              download
              class="btn w-100 p-3 text-blue text-uppercase font-weight-bold bg-yellow"
              >{{ $_t("KW:downloadPdf") }}</a
            >
          </div>
        </div>
      </li>
    </ul>
    <LightBox
      :images="lightboximg"
      :show-light-box="false"
      ref="lightbox"
      show-caption
    ></LightBox>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
import LightBox from "vue-image-lightbox";

export default {
  i18nOptions: {
    namespaces: "pages",
    keyPrefix: "approbations",
  },
  metaInfo: function () {
    return { title: this.$_t("pages:approbations.meta") };
  },
  components: {
    Carousel: Carousel,
    Slide: Slide,
    LightBox: LightBox,
  },
  computed: {
    lightboximg: function () {
      let result = [];
      if (this.approbations) {
        this.approbations.forEach((approbation) => {
          let srcimg = approbation.full
            ? approbation.full.url
            : approbation.preview.url;
          result.push({
            thumb: approbation.preview.url,
            src: srcimg,
            caption: "<b>" + approbation.name + "</b>",
          });
        });
      }
      return result;
    },
  },
  data: function () {
    return {
      approbations: null,
    };
  },
  created: function () {
    this.getData();
  },
  methods: {
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    },
    getData: function () {
      this.$http
        .get("/api/approbations")
        .then((response) => (this.approbations = response.data));
    },
  },
};
</script>
